import React, { Component } from 'react';
import Dimensions from 'react-dimensions'
import ReactPlayer from 'react-player';
import logo from './logo.png';
import './App.css';


var firebase = require("firebase");

// Initialize Firebase
var config = {
  apiKey: "AIzaSyBzcVqyDjHXbVNmF5pbBOzDmyGszjjZIAc",
  authDomain: "iradio-5150a.firebaseapp.com",
  databaseURL: "https://iradio-5150a.firebaseio.com",
  projectId: "iradio-5150a",
  storageBucket: "iradio-5150a.appspot.com",
  messagingSenderId: "304887383493"
};
firebase.initializeApp(config);


class App extends Component {

  constructor (props) {
     super(props)
     this.state = {dimensions: undefined}
   }

   loadStations() {
     var defaultDatabase = firebase.database();
     var dataRef = defaultDatabase.ref('web/stations');

     var stationsMap = {};

     dataRef.once('value', (snap) => {
       let index=1;
       snap.forEach((child) => {
         var movie = {
           ad: false,
           image: child.val().image,
           index: child.val().index,
           name: child.val().name,
           url: child.val().url,
           categoryid: child.val().categoryid,
           urlXML: child.val().urlXML,
           _key: child.key
         };

         var stations = stationsMap[movie.categoryid];
         if (stations==null)
          stations = [];
         stations.push(movie);
         stationsMap[movie.categoryid] = stations;

         if ((index%4) === 0 ) {
           // transactions.push ({ad:true,first:true});
           // transactions.push ({ad:true,first:false});
         }
         index = index + 1;
       });
         this.setState({
           stationsMap: stationsMap
         });
     });
   }


  loadTop25() {
    var defaultDatabase = firebase.database();
    var dataRef = defaultDatabase.ref('web/top25');

    dataRef.once('value', (snap) => {
      var transactions = [];
      let index=1;
      snap.forEach((child) => {
        var movie = {
          ad: false,
          image: child.val().image,
          index: child.val().index,
          name: child.val().name,
          url: child.val().url,
          urlXML: child.val().urlXML,
          _key: child.key
        };
        transactions.push(movie);

        if ((index%4) === 0 ) {
          // transactions.push ({ad:true,first:true});
          // transactions.push ({ad:true,first:false});
        }
        index = index + 1;
      });
        this.setState({
          top25: transactions
        });
    });
  }

  loadCategories() {
    var defaultDatabase = firebase.database();
    var dataRef = defaultDatabase.ref('web/categories');

    dataRef.once('value', (snap) => {
      var transactions = [];
      let index=1;
      snap.forEach((child) => {
        var movie = {
          ad: false,
          categoryicon: child.val().categoryicon,
          categoryid: child.val().categoryid,
          name: child.val().name,
          _key: child.key
        };
        transactions.push(movie);

        if ((index%4) === 0 ) {
          // transactions.push ({ad:true,first:true});
          // transactions.push ({ad:true,first:false});
        }
        index = index + 1;
      });
        this.setState({
          categories: transactions,
        });
    });
  }

  componentDidMount() {
    console.log ('signInAnonymously');
    var mythis = this;
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        mythis.loadTop25();
        mythis.loadCategories();
        mythis.loadStations();
      } else {
      }
    });

    firebase.auth().signInAnonymously().catch(function(error) {
      console.log ('signInAnonymously catch');
      var errorCode = error.code;
      if (errorCode === 'auth/operation-not-allowed') {
        alert('You must enable Anonymous auth in the Firebase Console.');
      } else {
        console.error(error);
      }
    });

  }

  stationClicked(station) {
    this.setState({selectedStation: station});
  }
  categoryClicked(category) {
    var stationsOfCategory = this.state.stationsMap[category.categoryid]
    this.setState({selectedCategory: category, stationsOfCategory: stationsOfCategory});
  }

  listCategoris () {
    return this.state.categories.map((category) =>
      <div className="grid-item">
      <button onClick={this.categoryClicked.bind(this,category)}>
      <img src={category.categoryicon} height="100" width="100" alt=""/>
      {category.name}
      </button>
      </div>
    );
  }
  listTop25 () {
    return this.state.top25.map((station) =>
      <div className="grid-item">
      <button onClick={this.stationClicked.bind(this,station)}>
      <img src={station.image} height="60" width="100" alt=""/>
      <br></br>
      {station.name}
      </button>
      </div>
    );
  }

  listStationsOfCategory () {
    return this.state.stationsOfCategory.map((station) =>
      <div className="grid-item" containerWidth={this.props.containerWidth}>
      <button onClick={this.stationClicked.bind(this,station)}>
      <img src={station.image} height="60" width="100" alt=""/>
      <br></br>
      {station.name}
      </button>
      </div>
    );
  }

  render() {
    return (
      <div className="App" containerWidth={this.props.containerWidth}>
      <header className="App-header" >
      <div style={{float:'left'}}><img src={logo} className="App-logo" alt=""/></div>
      <div style={{float:'left'}}><h1 className="App-title">Welcome to iRadio</h1></div>
      <div style={{clear:'both'}}/>
      </header>

      {this.state && !this.state.top25 && (
        <div>
        <p><h1>Loading information</h1></p>
        </div>
      )}
      <br/><br/>
      {this.state && this.state.selectedStation &&(
        <div containerWidth={this.props.containerWidth}>
        <ReactPlayer  url={this.state.selectedStation.url} playing controls height='20px' width='50%' style={{top:'50px', paddingLeft:'25%',height:'20px'}}/>
        </div>
      )}

      {this.state && this.state.top25 && (
        <div>
        <h1>תחנות מובילות</h1>
        <div className="grid-container">
        {this.listTop25()}
        </div>
        </div>
      )}
      {this.state && this.state.categories && (
        <div><h1>קטגוריות</h1>
        <div className="grid-container">
        {this.listCategoris()}
        </div>
        </div>
      )}
      {this.state && this.state.stationsOfCategory && (
        <div><h1>{this.state.selectedCategory.name}</h1>
        <div className="grid-container">
        {this.listStationsOfCategory()}
        </div>
        </div>
      )}
      </div>
    );
  }

  onLayout = event => {
  if (this.state.dimensions) return // layout was already called
  let {width, height} = event.nativeEvent.layout
  this.setState({dimensions: {width, height}})
}
}

export default Dimensions() (App);



// WEBPACK FOOTER //
// ./src/App.js